<ng-container *ngIf="locationForm">
	<header class="location-form-header">
		<h2 class="location-form-title">{{ editing?.loccode ? ('Edit ' + (editing.orignalname || editing.loccode)) : 'Add Location' }}</h2>
		<div class="location-form-actions">
			<button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
			<button mat-raised-button color="accent" type="button" (click)="updateLocation()" [disabled]="saving">
				{{ saving ? 'Saving…' : 'Save' }}
			</button>
		</div>
	</header>

	<div class="save-error" *ngIf="saveError">
		<mat-icon>error</mat-icon>
		{{ saveError }}
	</div>

	<form [formGroup]="locationForm" class="location-form">
		<section class="form-section">
			<h3 class="section-title">Location</h3>
			<div class="section-grid">
				<mat-form-field appearance="outline" class="field-full">
					<mat-label>Location Code</mat-label>
					<input matInput formControlName="loccode" placeholder="e.g. 01">
					<mat-error *ngIf="locationForm.get('loccode')?.hasError('required')">Required</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="field-full">
					<mat-label>Location Name</mat-label>
					<input matInput formControlName="locationname" placeholder="Location Name">
					<mat-error *ngIf="locationForm.get('locationname')?.hasError('required')">Required</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="field-full">
					<mat-label>Address 1</mat-label>
					<input matInput formControlName="deladd1" placeholder="Address 1">
					<mat-error *ngIf="locationForm.get('deladd1')?.hasError('required')">Required</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="field-full">
					<mat-label>Address 2</mat-label>
					<input matInput formControlName="deladd2" placeholder="Address 2">
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>City</mat-label>
					<input matInput formControlName="deladd3" placeholder="City">
					<mat-error *ngIf="locationForm.get('deladd3')?.hasError('required')">Required</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Region</mat-label>
					<mat-select formControlName="deladd4">
						<mat-option *ngFor="let zone of (zones?.zones || [])" [value]="zone.code">{{ zone.code }} {{ zone.name }}</mat-option>
					</mat-select>
					<mat-error *ngIf="locationForm.get('deladd4')?.hasError('required')">Required</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Postal Code</mat-label>
					<input matInput formControlName="deladd5" placeholder="Postal">
					<mat-error *ngIf="locationForm.get('deladd5')?.hasError('required')">Required</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="field-full">
					<mat-label>Country</mat-label>
					<mat-select formControlName="deladd6" (selectionChange)="updateZones($event)">
						<mat-option *ngFor="let zone of (zones?.countries || [])" [value]="zone.name">{{ zone.name }}</mat-option>
					</mat-select>
					<mat-error *ngIf="locationForm.get('deladd6')?.hasError('required')">Required</mat-error>
				</mat-form-field>
			</div>
		</section>

		<section class="form-section">
			<h3 class="section-title">Contact</h3>
			<div class="section-grid section-grid--contact">
				<mat-form-field appearance="outline">
					<mat-label>Contact Name</mat-label>
					<input matInput formControlName="contact" placeholder="Contact Name">
					<mat-error *ngIf="locationForm.get('contact')?.hasError('required')">Required</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Email</mat-label>
					<input matInput formControlName="email" type="email" placeholder="Email">
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Phone</mat-label>
					<input matInput formControlName="tel" placeholder="Phone">
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Fax</mat-label>
					<input matInput formControlName="fax" placeholder="Fax">
				</mat-form-field>
			</div>
		</section>

		<section class="form-section">
			<h3 class="section-title">Tax</h3>
			<div class="section-grid section-grid--tax">
				<mat-form-field appearance="outline" *ngIf="taxes?.length">
					<mat-label>Tax Authority (with cert)</mat-label>
					<mat-select formControlName="taxgroupid_cert">
						<mat-option *ngFor="let tax of taxes" [value]="tax.taxgroupid">{{ tax.taxgroupdescription }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline" *ngIf="taxes?.length">
					<mat-label>Tax Authority (without cert)</mat-label>
					<mat-select formControlName="taxgroupid">
						<mat-option *ngFor="let tax of taxes" [value]="tax.taxgroupid">{{ tax.taxgroupdescription }}</mat-option>
					</mat-select>
					<mat-error *ngIf="locationForm.get('taxgroupid')?.hasError('required')">Required</mat-error>
				</mat-form-field>
			</div>
		</section>

		<section class="form-section">
			<h3 class="section-title">Receipt Message</h3>
			<div class="receipt-editor-wrap">
				<app-wysiwyg-editor
					[input]="locationForm.get('receipt_message')"
					[changed]="editing?.loccode"
					(data)="locationForm.get('receipt_message').setValue($event)">
				</app-wysiwyg-editor>
			</div>
		</section>

		<section class="form-section">
			<h3 class="section-title">Location Defaults</h3>
			<div class="section-grid section-grid--defaults">
				<mat-form-field appearance="outline">
					<mat-label>Default Country</mat-label>
					<mat-select formControlName="defcountry">
						<mat-option *ngFor="let zone of (zones?.countries || [])" [value]="zone.name">{{ zone.name }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Default Region</mat-label>
					<mat-select formControlName="defregion">
						<mat-option *ngFor="let zone of (zones?.zones || [])" [value]="zone.code">{{ zone.code }} {{ zone.name }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>A/R Status</mat-label>
					<mat-select formControlName="defholdreason">
						<mat-option *ngFor="let hr of holdreasons" [value]="hr.reasoncode">{{ hr.reasoncode }} – {{ hr.reasondescription }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Currency</mat-label>
					<mat-select formControlName="defcurrency">
						<mat-option *ngFor="let cur of currencies" [value]="cur.currabrev">{{ cur.currabrev }} – {{ cur.currency }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Payment Terms</mat-label>
					<mat-select formControlName="defterms">
						<mat-option *ngFor="let term of terms" [value]="term.termsindicator">{{ term.termsindicator }} {{ term.terms }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Price Level</mat-label>
					<mat-select formControlName="defsalestype">
						<mat-option *ngFor="let type of salestypes" [value]="type.typeabbrev">{{ type.typeabbrev }} – {{ type.sales_type }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Customer Type</mat-label>
					<mat-select formControlName="defcustomertype">
						<mat-option *ngFor="let type of types" [value]="type.typeid">{{ type.typename }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Discount %</mat-label>
					<input matInput formControlName="defdiscount" type="text" placeholder="0">
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Credit Limit</mat-label>
					<input matInput formControlName="defcredit" type="text" placeholder="0">
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Email Invoice</mat-label>
					<mat-select formControlName="defemail_invoice">
						<mat-option value="Y">Yes</mat-option>
						<mat-option value="N">No</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Email Statement</mat-label>
					<mat-select formControlName="defemail_statement">
						<mat-option value="Y">Yes</mat-option>
						<mat-option value="N">No</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>PO Required</mat-label>
					<mat-select formControlName="defrequirepo">
						<mat-option value="1">Yes</mat-option>
						<mat-option value="0">No</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Interest Rate</mat-label>
					<input matInput formControlName="definterest" type="text">
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Warehouse</mat-label>
					<mat-select formControlName="defwarehouse">
						<mat-option *ngFor="let l of locations" [value]="l.loccode">{{ l.loccode }} – {{ l.orignalname || l.locationname }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Shipping Method</mat-label>
					<mat-select formControlName="defshipvia">
						<mat-option *ngFor="let l of shipvia" [value]="l.shipper_id">{{ l.shippername }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Area</mat-label>
					<mat-select formControlName="defarea">
						<mat-option *ngFor="let area of areas" [value]="area.areacode">{{ area.areacode }} – {{ area.areadescription }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Territory</mat-label>
					<mat-select formControlName="defterritory">
						<mat-option *ngFor="let area of territory" [value]="area.territory_id">{{ area.territory_id }} – {{ area.territory_name }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Salesperson</mat-label>
					<mat-select formControlName="defsalesperson">
						<mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">{{ sp.salesmancode }} – {{ sp.salesmanname }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Customers Disabled</mat-label>
					<mat-select formControlName="defdisabled">
						<mat-option value="1">Yes</mat-option>
						<mat-option value="0">No</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Tax Authority</mat-label>
					<mat-select formControlName="deftaxauth">
						<mat-option *ngFor="let tax of taxes" [value]="tax.taxgroupid">{{ tax.taxgroupid }} – {{ tax.taxgroupdescription }}</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Branch Code</mat-label>
					<input matInput formControlName="defbranchcode" placeholder="00">
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Payment Method</mat-label>
					<mat-select formControlName="defpayment_method">
						<mat-option *ngFor="let p of paymethod" [value]="p.paymentid">{{ p.paymentname }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</section>
	</form>
</ng-container>
